import { ResponsiveContainer, BarChart, Bar, Cell, XAxis, YAxis, Tooltip } from "recharts";
import { ChartCard } from "./Card";
import { tokens } from "./styles";

// How the cohort is spread across the readiness bands, with the candidate's own
// band highlighted — "most of your cohort is here; you're there."
export function bandsVisible(data) {
  return Boolean(data?.available);
}

export default function BandBreakdown({ data }) {
  if (!bandsVisible(data)) return null;

  const { breakdown, cohort_size, your_band } = data;
  const yours = breakdown.find((b) => b.is_you);

  return (
    <ChartCard
      title="Readiness across the cohort"
      hint={your_band
        ? `You're in the “${yours?.label}” band of ${cohort_size} candidates`
        : `Across ${cohort_size} candidates`}
    >
      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={breakdown} margin={{ top: 4, right: 8, left: -20, bottom: 0 }}>
          <XAxis dataKey="label" tick={{ fontSize: 11, fill: tokens.ink500 }} interval={0} />
          <YAxis unit="%" tick={{ fontSize: 10, fill: tokens.ink400 }} />
          <Tooltip
            cursor={{ fill: tokens.surface }}
            formatter={(value, _name, item) => [`${value}% (${item?.payload?.count} candidates)`, "Share"]}
          />
          <Bar dataKey="share" radius={[3, 3, 0, 0]}>
            {breakdown.map((d, i) => (
              <Cell key={i} fill={d.is_you ? tokens.accent : tokens.ink300} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}
